/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import * as React from 'react';
import Footer from 'src/components/Footer/medicaid/Footer';
import Header from 'src/components/Header';

export interface PageProps {
  hideContact?: boolean;
  hideSocial?: boolean;
}

export const Page: React.FC<PageProps> = ({ children, ...props }) => {
  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth
  });

  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }
    window.addEventListener('resize', handleResize);
    return function cleanup() {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div>
      <Header className="self-referral-header" />
      {children}
      <Footer
        className="self-referral-footer"
        dimensions={dimensions}
        {...props}
      />
    </div>
  );
};
